export const MESSAGES = ['messages'];
export const DEPRECATED_MESSAGES = ['deprecatedMessages'];
export const MESSAGE_RESULTS = ['messages', 'results'];
export const MESSAGE_HAS_MORE = ['messages', 'hasMore'];
export const MESSAGE_OFFSET = ['messages', 'offset'];
export const OFFSET_TIMESTAMP = ['messages', 'offset', 'timestamp'];
export const OFFSET_ORDINAL = ['messages', 'offset', 'ordinal'];
export const VISITOR_LAST_READ_AT_TIMESTAMP = ['visitorLastReadAtTimestamp'];
export const NUM_SOFT_DELETED_MESSAGES = ['numSoftDeletedMessages'];
export const ATTACHMENTS = ['attachments'];
export const FILE_ATTACHMENTS = ['attachments', 'files'];
export const DIRECT_REPLIES = ['directReplies', 'directReplyMessages'];
export const FRIENDLY_NAME_RESULTS = ['friendlyNameResults'];